export const getMessenger = (waSessionId) => {
  // waSessionId deve estar no formato:
  // api-1 => Api original (não oficial)
  // whatsapp-12313221312 => Api oficial whatsapp
  // telegram-sadfasfd => Api telegram (não implementado ainda)
  const [messenger] = waSessionId.split('-');
  return messenger;
};
